var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElementButton',{attrs:{"name":"download","i18n":"","content":_vm.content,"state":_vm.partState,"data-url":"command://noOp"},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }